import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'outcomesGCGroupCharts',
    label: 'Outcomes Group Charts',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
